/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Agenda_Unscheduled_OneInputs */

const en_tl_agenda_unscheduled_one = /** @type {(inputs: Tl_Agenda_Unscheduled_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 item has no dates yet.`)
};

const de_tl_agenda_unscheduled_one = /** @type {(inputs: Tl_Agenda_Unscheduled_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Vorgang hat noch keine Termine.`)
};

/**
* | output |
* | --- |
* | "1 item has no dates yet." |
*
* @param {Tl_Agenda_Unscheduled_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_agenda_unscheduled_one = /** @type {((inputs?: Tl_Agenda_Unscheduled_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Agenda_Unscheduled_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_agenda_unscheduled_one(inputs)
	return en_tl_agenda_unscheduled_one(inputs)
});